'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _Sorter = require('../helpers/Sorter');

var _Establishment = require('../models/Establishment');

var _VacationRental = require('../models/VacationRental');

var _Hotel = require('../models/Hotel');

var _constants = require('../constants');

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function matchFunction(obj) {
  return function (elem) {
    return Object.keys(obj).reduce(function (acc, key) {
      return elem[key] === obj[key] && acc;
    }, true);
  };
}

function reducePriceRanges(priceRanges, newPrices) {
  if (!priceRanges) {
    return {
      minDayPrice: newPrices.minDayPrice,
      minTotalPrice: newPrices.minTotalPrice,
      maxDayPrice: newPrices.minDayPrice,
      maxTotalPrice: newPrices.minTotalPrice
    };
  }

  return {
    minDayPrice: newPrices.minDayPrice < priceRanges.minDayPrice ? newPrices.minDayPrice : priceRanges.minDayPrice,
    minTotalPrice: newPrices.minTotalPrice < priceRanges.minTotalPrice ? newPrices.minTotalPrice : priceRanges.minTotalPrice,
    maxDayPrice: newPrices.minDayPrice > priceRanges.maxDayPrice ? newPrices.minDayPrice : priceRanges.maxDayPrice,
    maxTotalPrice: newPrices.minTotalPrice > priceRanges.maxTotalPrice ? newPrices.minTotalPrice : priceRanges.maxTotalPrice
  };
}

var EstablishmentCollection = function () {
  function EstablishmentCollection() {
    _classCallCheck(this, EstablishmentCollection);

    this.propertiesMap = null;
    this.collection = [];
    this.dictionary = {};
    this.priceRanges = null;
  }

  _createClass(EstablishmentCollection, [{
    key: 'dispatchCreateElement',
    value: function dispatchCreateElement(element) {
      var _fns;

      var fns = (_fns = {}, _defineProperty(_fns, _constants.ESTAB, _Establishment.createEstablishment), _defineProperty(_fns, _constants.VACATION_RENTAL, _VacationRental.createVacationRental), _defineProperty(_fns, _constants.HOTEL, _Hotel.createHotel), _fns);

      return fns[element.type](element);
    }
  }, {
    key: 'dispatchAddOfferToResult',
    value: function dispatchAddOfferToResult(offer, result, dateArrival, numberOfDays) {
      var _fns2;

      var fns = (_fns2 = {}, _defineProperty(_fns2, _constants.ESTAB_OFFER, _Establishment.addPublicationToEstablishment), _defineProperty(_fns2, _constants.VACATION_RENTAL_OFFER, _VacationRental.addOfferToVacationRental), _defineProperty(_fns2, _constants.HOTEL_OFFER, _Hotel.addOfferToHotel), _fns2);

      return fns[offer.type](offer, result, dateArrival, numberOfDays);
    }
  }, {
    key: 'map',
    value: function map(elems) {
      var _this = this;

      return elems.reduce(function (acu, result) {
        if (!_this.dictionary[result.id]) acu[result.id] = _this.dispatchCreateElement(result);else acu[result.id] = _this.dictionary[result.id];

        return acu;
      }, {});
    }
  }, {
    key: 'append',
    value: function append(results) {
      var _this2 = this;

      if (!results) return {};
      var parsedResults = {};
      Object.keys(results).filter(function (key) {
        return results[key];
      }).forEach(function (type) {
        if (_constants.PROPERTY_TYPES.includes(type)) {
          results[type].forEach(function (result) {
            if (!_this2.dictionary[result.id]) {
              var elem = _this2.dispatchCreateElement(result);
              parsedResults[elem.id] = elem;
              _this2.collection.push(elem.id);
              _this2.dictionary[elem.id] = elem;
            }
          });
        }
      });

      return parsedResults;
    }
  }, {
    key: 'addPrices',
    value: function addPrices(rawResults, parsedResults, dateArrival, numberOfDays) {
      var _this3 = this;

      Object.keys(rawResults).forEach(function (type) {
        if (_constants.OFFER_TYPES.includes(type)) {
          rawResults[type].forEach(function (offer) {
            var result = _this3.dictionary[offer.establishment_id];

            if (!result) return null;

            result = _extends({}, _this3.dispatchAddOfferToResult(offer, result, dateArrival, numberOfDays));
            _this3.priceRanges = reducePriceRanges(_this3.priceRanges, {
              minDayPrice: result.minDayPrice,
              minTotalPrice: result.minTotalPrice
            });

            parsedResults[result.id] = result;
          });
        }
      });

      return parsedResults;
    }
  }, {
    key: 'getPriceRanges',
    value: function getPriceRanges() {
      return JSON.parse(JSON.stringify(this.priceRanges));
    }
  }, {
    key: 'sort',
    value: function sort(sorting) {
      this.collection = (0, _Sorter.sort)(this.collection, this.dictionary, sorting);
      return this.collection;
    }
  }, {
    key: 'updateInfo',
    value: function updateInfo(id, data) {
      var idx = this.getIndex({ id: id });
      this.collection[idx] = _extends({}, this.collection[idx], data);
    }
  }, {
    key: 'exists',
    value: function exists(obj) {
      return this.getIndex(obj) >= 0;
    }
  }, {
    key: 'get',
    value: function get(obj) {
      return this.collection.filter(matchFunction(obj))[0];
    }
  }, {
    key: 'getIndex',
    value: function getIndex(obj) {
      return this.collection.findIndex(matchFunction(obj));
    }
  }, {
    key: 'getById',
    value: function getById(id) {
      return this.dictionary[id];
    }
  }, {
    key: 'reset',
    value: function reset() {
      var initState = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

      this.collection.length = 0;
      this.dictionary = {};
      if (initState) {
        this.collection = [].concat(_toConsumableArray(initState.collection));
        this.dictionary = _extends({}, initState.dictionary);
      }
      this.priceRanges = null;
    }
  }, {
    key: 'remove',
    value: function remove(id) {
      var index = this.collection.indexOf(id);
      if (index > -1) this.collection.splice(index, 1);
      return this.collection;
    }
  }, {
    key: 'addRecommendation',
    value: function addRecommendation(id) {
      this.dictionary[id].recommendation = true;
    }
  }, {
    key: 'toJSON',
    value: function toJSON() {
      var _this4 = this;

      return this.collection.map(function (id) {
        return _this4.dictionary[id];
      });
    }
  }]);

  return EstablishmentCollection;
}();

exports.default = EstablishmentCollection;